<template>
    <div class="reportPage" id="answer-reports">
      <!--  <div class="content">
            <div class="reportHeader">
                <input type="text" v-model="params.name">
                <div class="btn" @click="search">搜索</div>
            </div>
            <div class="reportList" v-if="resultObj.list &&resultObj.list.length">
                 <div class="reportItem" v-for="(item,index) in resultObj.list" :key="index">
                     <div class="itemLeft">
                         <img :src="item.id | imgUrl(11)" alt="">
                     </div>
                     <div class="itemRight">
                         <div class="itemTitle">{{item.name}}</div>
                     </div>
                     <div class="itemTime">

                         {{item.createTime | YearDate}}

                         <a-popconfirm
                                 title="确认下载此份报告?"
                                 ok-text="确认"
                                 cancel-text="取消"
                                 @confirm="downFile(item)"
                                 @cancel="cancel"
                         >
                             <a href="#" style="margin-left: 10px">下载</a>
                         </a-popconfirm>
                     </div>
                 </div>

                <a-pagination v-if="resultObj.totalPage>1" show-quick-jumper :default-current="1" :total="resultObj.totalCount" @change="onChange" />
            </div>
            <div v-else style="text-align: center;margin: 30px 0">
                暂无数据
            </div>
        </div>-->

        <div class="content">
<!--            <div class="row">-->
<!--                <span class="f14">标题</span>-->
<!--                <a-input v-model="params.name" class="search-input" size="small" />-->

<!--                <span class="f14">日期</span>-->
<!--                &lt;!&ndash; 日历 &ndash;&gt;-->
<!--                <a-date-picker-->
<!--                        class="search-input"-->
<!--                        size="small"-->
<!--                        placeholder="请输入创建日期"-->
<!--                        v-model="params.time"-->
<!--                        @change="datePickerChange"-->
<!--                />-->

<!--                <a-button class="btn" type="primary" size="small" @click="search">查询</a-button>-->

<!--            </div>-->

            <div class="reportHead">
                <div class="reportSearchBox">
                    <div class="reportSearch">
                        <div class="searchPicker">
                            {{PickerList[PickerIndex].name}}
                            <div class="pickerIcon icon el-icon-caret-bottom"></div>
                            <div class="PickerList">
                                <div class="PickerItem" v-for="(item,index) in PickerList" :key="index" @click="pickerChange(index)"> {{item.name}} </div>
                                <!--                                <div class="PickerItem">时间</div>-->
                            </div>
                        </div>
                        <div class="searchInput">
                            <input v-if="PickerIndex===0" v-model="params.name" type="text" placeholder="输入主题">
                            <input v-if="PickerIndex===1" v-model="params.time" type="text" placeholder="输入创建时间 格式为:2021-01-01">
                        </div>
                        <div class="searchBtn" @click="search">
                            <div class="icon el-icon-search"></div>
                        </div>
                    </div>
<!--                    <div class="reportAddBtn">新建解读报告</div>-->
                </div>
            </div>

            <a-table
                    v-if="resultObj.list"
                    :columns="columns"
                    :dataSource="resultObj.list"
            >

                <div slot="img" slot-scope="id" class="img-wrap">
                    <img :src="id | imgUrl(11)" alt="">
                </div>
                <div slot="name" slot-scope="name" class="title text-overflow">
                    {{name}}
                </div>
                <div slot="createTime" slot-scope="createTime" class="title text-overflow">
                    {{createTime | YearDate}}
                </div>

                <div slot="operation" slot-scope="text, record" class="type">
                    <template>
                        <a-popconfirm
                                title="确认下载此份报告?"
                                ok-text="确认"
                                cancel-text="取消"
                                @confirm="downFile(record)"
                                @cancel="cancel"
                        >
                            <a href="#" style="margin-left: 10px">下载</a>
                        </a-popconfirm>
                    </template>
                </div>
            </a-table>
            <a-empty v-else />
        </div>
    </div>
</template>

<script>
    import UrlApi from "../../utils/UrlApi"
    export default {
        name: "pushReport",
        data(){
            return {
                params:{
                    page: 1,
                    pageSize: 10,
                    type: '1',
                    name:''
                },
                resultObj:{},
                columns:[
                    {title: '序号',dataIndex: 'index',key: 'index',width: '7%'},
                    {title: '缩略图',dataIndex: 'id',key: 'id',
                        scopedSlots: { customRender: 'img' }},
                    {title: '报告标题',dataIndex:'name',key: 'name',
                        scopedSlots: { customRender: 'name' }},
                    {title: '时间',dataIndex: 'createTime',key: 'createTime', scopedSlots: { customRender: 'createTime' }},
                    {
                        title: '操作',
                        dataIndex: 'operation',
                        scopedSlots: { customRender: 'operation' },
                    }
                ],
                pagination:{
                    page:1,
                    pageSize:7,
                    totalPage:0,
                    total: 0,
                    onChange: (page) => this.onChange(page)
                },
                PickerList:[
                    {name:'主题',id:1},
                    {name:'时间',id:2},
                ],
                PickerIndex:0

            }
        },
        mounted(){
          this.getList()
        },
        methods:{
            pickerChange(index){
                this.PickerIndex= index
                this.params.name =''
                this.params.time =''
                this.search()
            },
            search(){
                this.params.page = 1
                this.getList()
            },
            getList(){
                this.$http.get(UrlApi.informList,{
                    params:this.params,
                }).then((res)=>{
                    let {success,message} = res.data;
                    if(success){
                        this.resultObj = res.data.data

                        if(this.resultObj && this.resultObj.list){
                            this.resultObj.list.map((item,index)=>{
                                item.index = index+1;
                                //item.coverImageUrl = "http://49.233.189.220:8080/unsafe/asset/ep/app/thumbnail/气象成因_02气象参数空间插值图.png?v3"
                            })
                        }
                        // this.$message.success(message);
                        // this.showShareModal(res.data.data)
                    }else {
                        this.$message.warning(message);
                    }
                })
            },
            onChange(pageNumber) {
                this.params.page = pageNumber
                this.getList()
                // console.log('Page: ', pageNumber);
            },
            downFile(data){
                console.log(data)
                var fileName = data.path
                var first = fileName.lastIndexOf(".");//取到文件名开始到最后一个点的长度
                var namelength = fileName.length;//取到文件名长度
                var filesuffix = fileName.substring(first + 1, namelength );//截取获得后缀名
                // id,token,contentType=word,type=1
                console.warn('============filesuffix========')
                console.log(filesuffix)

                let contentType = filesuffix === 'pdf' ? 'pdf' : 'word'
                //
                // console.log(url.minioDownloads + '?id=' + data.id + '&contentType='+contentType
                //     + '&type=1&token=' + this.data.token)
                let url =UrlApi.minioDownloads + '?id=' + data.id + '&contentType='+contentType
                    + '&type=1&token='+localStorage.getItem('token')
                window.open(url)
            },
            cancel(e) {
                console.log(e);
            },
            datePickerChange(momentDate,date){
                this.params.time = date;
            },
        }
    }
</script>

<style lang="less" scoped>
    @import "exportList";
</style>